"use client";

/**
 * Activar código 7.7 — ingreso del código único de distribuidor.
 */

import { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { BottomNav, HeaderTitulo } from "@/components/app/chrome";
import { useApp } from "@/components/app/proveedor";

export default function PaginaCodigoDistribuidor() {
  const router = useRouter();
  const { usuario, refrescarUsuario } = useApp();
  const [codigo, setCodigo] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);

  async function activar() {
    if (cargando) return;
    if (!usuario) {
      router.push("/acceso?next=/distribuidores/codigo");
      return;
    }
    setError(null);
    setCargando(true);
    try {
      const res = await fetch("/api/distribuidores/activar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ codigo }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        setError(data.error ?? "Ese código no está activo.");
        return;
      }
      await refrescarUsuario();
      router.push("/mayorista");
    } catch {
      setError("Sin conexión. Intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  }

  return (
    <>
      <HeaderTitulo titulo="Código de distribuidor" />
      <main className="anim-bz-in min-h-(--alto-app) px-7 pt-[100px] pb-[62px]">
        <div className="pt-10">
          <h1 className="font-app text-2xl leading-7 font-black">
            Activa tus precios mayoristas
          </h1>
          <p className="mt-2.5 text-sm leading-[21px] text-tinta/65">
            Ingresa el código que te enviamos por WhatsApp cuando aprobamos tu
            negocio.
          </p>

          <input
            value={codigo}
            onChange={(e) => setCodigo(e.target.value.toUpperCase())}
            placeholder="BZ-DIST-••••"
            className="mt-[26px] h-[72px] w-full rounded-3xl border-[1.5px] border-verde/40 bg-white text-center font-app text-xl font-semibold tracking-[2px] outline-0 placeholder:text-tinta/30"
          />

          {error && <p className="mt-3 text-sm text-[#B4463A]">{error}</p>}

          <button
            type="button"
            onClick={() => void activar()}
            disabled={cargando || !codigo.trim()}
            className="mt-4 flex h-16 w-full items-center justify-center rounded-[30px] bg-verde font-app text-[17px] font-semibold text-white transition active:scale-[.98] disabled:opacity-60"
          >
            {cargando ? "Activando…" : "Activar"}
          </button>

          <div className="mt-5 rounded-[20px] bg-humo p-4 text-[13px] leading-[19px] text-tinta/65">
            Un código por negocio. Si lo perdiste, escríbenos por WhatsApp con tu
            RUC.
          </div>

          <Link
            href="/distribuidores"
            className="mt-[18px] block text-center text-[13px] text-tinta/60 underline"
          >
            Todavía no me registro
          </Link>
        </div>
      </main>
      <BottomNav />
    </>
  );
}
